// Central business configuration. Reused by header, footer, forms, SEO and city pages.
// Owner-confirmed contact details (30 Sept 2026). These override any old-site numbers.

export const SITE = {
  brand: "Jitendra Singh Tour Operator Service",
  shortBrand: "Jitendra Singh Tours",
  baseCity: "Satna",
  region: "Madhya Pradesh",
  addressShort: "Satna, Madhya Pradesh",
  domain: "https://touroperatorservices.com",
  email: "info@touroperatorservice.com",
  phonePrimary: { display: "+91 96857 64656", tel: "+919685764656", wa: "919685764656" },
  phoneSecondary: { display: "+91 94249 73323", tel: "+919424973323", wa: "919424973323" },
  hindiAssist:
    "सतना एवं संपूर्ण मध्य प्रदेश में टैक्सी एवं टेम्पो ट्रेवलर बुकिंग के लिए कॉल या व्हाट्सएप करें।",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Taxi Services", path: "/services" },
  { label: "Tempo Traveller", path: "/tempo-traveller", badge: "Popular" },
  { label: "Fleet", path: "/fleet" },
  { label: "Service Areas", path: "/service-areas" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const telHref = (tel) => `tel:${tel}`;

export const waHref = (wa, text) =>
  `https://wa.me/${wa}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const DEFAULT_WA_TEXT =
  "Namaste Jitendra ji, I would like to enquire about booking a taxi / Tempo Traveller. Please share availability and a quote.";

// Build a readable WhatsApp enquiry message from trip details.
export function buildTripMessage(trip = {}) {
  const lines = ["Namaste Jitendra ji, I would like to request a taxi / Tempo Traveller quote.", ""];
  const add = (label, val) => {
    if (val && String(val).trim()) lines.push(`${label}: ${String(val).trim()}`);
  };
  add("Name", trip.name);
  add("Trip type", trip.trip_type);
  add("Pickup city", trip.pickup_city);
  add("Pickup point", trip.pickup_point);
  add("Destination", trip.destination);
  add("Travel date", trip.travel_date);
  add("Travel time", trip.travel_time);
  add("Return date", trip.return_date);
  add("Passengers", trip.passengers);
  add("Luggage", trip.luggage_note);
  add("Vehicle", trip.vehicle_category);
  add("Vehicle preference", trip.vehicle_preference);
  add("Notes", trip.message);
  add("Callback number", trip.callback_phone);
  lines.push("", "Please confirm availability and fare. Thank you.");
  return lines.join("\n");
}

// Owner-approved models and seating options. Availability is confirmed on enquiry.
export const TRAVELLER_SEATS = [9, 13, 17, 20, 21, 26];
export const VEHICLE_CATEGORIES = ["Sedan", "SUV / MPV", "Tempo Traveller", "Not sure — help me choose"];
export const VEHICLE_PREFERENCES = {
  "Sedan": ["Swift Dzire", "Toyota Etios", "No preference"],
  "SUV / MPV": ["Maruti Brezza", "Maruti Ertiga", "Mahindra Bolero", "Mahindra Bolero Neo", "Mahindra Scorpio", "Force Trax Cruiser", "Toyota Innova Crysta", "Kia Carens", "No preference"],
  "Tempo Traveller": [...TRAVELLER_SEATS.map(seats => String(seats) + " seater"), "Help me choose"],
  "Not sure — help me choose": [],
};
export const TRIP_TYPES = [
  "Local (within city)",
  "One-way outstation",
  "Round trip",
  "Multi-day tour",
  "Railway station / Airport transfer",
  "Pilgrimage / Temple tour",
];
